import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({ title, subtitle, icon = 'ri-fire-line', moreTo, moreLabel = '查看全部' }: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2">
          <span className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
            <i className={`${icon} text-base`} />
          </span>
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap transition-colors cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}